import { Identity, ResponseWithCount } from '../../models/common.model';
import { DefaultFieldsProvider } from '../../models/default-form-fields.model';
import { CommonActionType } from './common.types';

export class CacheDefaultFields {
  static readonly type = CommonActionType.GET_DEFAULT_FIELDS;
  constructor(
    // Narrowed from the `ModuleService` union to the one method the handler
    // actually calls. Every concrete module service still satisfies this
    // structurally, so the 17 dispatch sites are unaffected — they just stop
    // advertising an API surface this action never touches.
    public readonly service: DefaultFieldsProvider,
    public readonly moduleName: string,
    public readonly key: string,
    public readonly fields: string[],
    public readonly refresh?: boolean,
  ) {}
}

export class GetIdentityList {
  static readonly type = CommonActionType.GET_IDENTITY_LIST;
  constructor(public readonly type?: string) {}
}

export class GetIdentityListSuccess {
  static readonly type = CommonActionType.GET_IDENTITY_LIST_SUCCESS;
  constructor(
    public readonly res: {
      response?: ResponseWithCount<Identity>;
      type?: string;
    },
  ) {}
}

export class GetIdentityListError {
  static readonly type = CommonActionType.GET_IDENTITY_LIST_ERROR;
  constructor(public readonly error?: unknown) {}
}

export class ResetAllDefaultFields {
  static readonly type = CommonActionType.RESET_ALL_DEFAULT_FIELDS;
}
